import { CdkTreeNode } from '@angular/cdk/tree';
import { Component, ElementRef, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { AppService } from '../../../../../app/app.service';
import { TreeComponentClass } from '../../../../../app/core/libraries/Tree/core/classes/treeComponent.class';
import { INode } from '../../../../../app/core/libraries/Tree/core/interfaces/INode';
import { TreeService } from '../../services/tree.service';

@Component({
    selector: 'tree-common',
    templateUrl: './tree-add-options.component.html',
    styleUrls: ['../../styles/treeStyle.scss'],
    providers: [TreeService],
})
export class TreeAddOptionsComponent extends TreeComponentClass implements OnInit {
    /** Список узлов во вьюшке */
    @ViewChildren('treeNode') declare nodesList: QueryList<CdkTreeNode<any>>;
    @ViewChildren('treeNodeRef') declare nodesRefList: QueryList<ElementRef>;
    @ViewChild('treeContainer') declare treeContainer: ElementRef;

    /**
     * Конструктор класса
     * @param appService - глобальный сервис приложения
     * @param service - сервис дерева
     * @param renderer - класс для работы с DOM
     */
    constructor(
        public appService: AppService,
        public service: TreeService,
        public renderer: Renderer2,
    ) {
        super(service);
    }

    /**
     * Проверка на установку опции
     * @param node - узел
     * @param item - дополнительная опция узла
     */
    isSetOption(node: INode, item: any): boolean {
        return node[item.field] == '1';
    }
    /**
     * Проверка промежуточного состояния чекбокса
     * @param node - узел
     * @param item - дополнительная опция узла
     */
    indeterminateOption(node: INode, item: any) {
        const descendants = this.treeControl.getDescendants(node);

        if (descendants.length === 0) {
            return false;
        }

        const descendantsAll = this.getAllDescendants(node);
        return (
            descendantsAll.some((child) => child[item.field] == '1') &&
            descendantsAll.some((child) => child[item.field] == '0')
        );
    }

    /** Получить всех потомков узла */
    private getAllDescendants(node, arr = []): any[] {
        const children = this.treeControl.getDescendants(node);
        children?.forEach((child) => {
            this.getAllDescendants(child, arr);
        });
        if (Array.isArray(children)) {
            arr = arr.concat(children);
        }
        return arr;
    }

    /**
     * Изменение состояния дополнительной опции
     * @param event - событие нажатия на чекбокс
     * @param node - текущий узел
     * @param item - дополнительная опция узла
     */
    changeOption(event: any, node: INode, item: any) {
        this.setOptionValue(event.checked ? '1' : '0', node, item.field);
        this.setParentOptions(event.checked ? '1' : '0', node, item.field);
    }

    /**
     * Установка дополнительных параметров ветки
     * @param value - значение
     * @param node - узел дерева
     * @param field - поле доп опции
     */
    setParentOptions(value: '1' | '0', node: INode, field) {
        const parent: INode | null = this.flatNodeMap.get(node.parent_id);
        if (value === '1') {
            if (parent) {
                parent[field] = value;
                this.setParentOptions(value, parent, field);
            }
        } else if (parent) {
            const children = this.treeControl.getDescendants(parent);
            if (children.some((child) => child[field] == '1')) {
                return;
            }
            parent[field] = value;
            if (parent) {
                this.setParentOptions(value, parent, field);
            }
        }
    }

    /**
     * Установка дополнительных параметров ветки
     * @param value - значение
     * @param node - узел дерева
     * @param field - поле доп опции
     */
    setOptionValue(value: '1' | '0', node: INode, field) {
        if (
            value === '1' &&
            !this.service.checklistSelection.isSelected(String(node?.id)) &&
            !this.descendantsPartiallySelected(node)
        ) {
            return;
        }

        node[field] = value;

        const children = this.treeControl.getDescendants(node);

        children.forEach((child) => {
            this.setOptionValue(value, child, field);
        });
    }
    /**
     * Проверка установки чекбокса
     * @param event - событие нажатия на чекбокс доп опции
     * @param node - текущий узел
     */
    checkAutoSet(event: any, node: INode): void {
        if (event.checked) {
            this.service?.config?.additionalOptions.forEach((item) => {
                if (item.hasOwnProperty('autoSet') && item.autoSet) {
                    this.setOptionValue('1', node, item.field);
                }
            });
        } else {
            this.service?.config?.additionalOptions.forEach((item) => {
                this.setOptionValue('0', node, item.field);
            });
        }
    }

    /**
     * Подсветка соответствующих узлов двух деревьев
     * @param isHovering - определяем ховер на узле
     * @param nodeId - id узла
     */
    onNodeHover(isHovering: boolean, nodeId: string): void {
        const isFirstTreeHovering = nodeId.startsWith('tree1node');
        const targetId = isFirstTreeHovering ? `tree2node-${nodeId.slice(10)}` : `tree1node-${nodeId.slice(10)}`;
        const hostElement = this.treeContainer.nativeElement.querySelector(`.${nodeId}`);
        const targetElement = this.treeContainer.nativeElement.querySelector(`.${targetId}`);
        const hoverClass = 'tree-hover';

        if (targetElement) {
            if (isHovering) {
                this.renderer.addClass(targetElement, hoverClass);
                this.renderer.addClass(hostElement, hoverClass);
            } else {
                this.renderer.removeClass(targetElement, hoverClass);
                this.renderer.removeClass(hostElement, hoverClass);
            }
        }
    }
}
